/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TWebUpdateFolderRequest, TWebUpdateFolderModel, IMappers, TWebUpdateFolderResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IFolderResponse2 } from '../../../entities/user_folder/FolderResponse2';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createWebUpdateFolderModel(parameters: TWebUpdateFolderRequest): TWebUpdateFolderModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'favorites',
    pathApi: '/v1/web/update-folder/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IWebUpdateFolderOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TWebUpdateFolderRequest;
}

export async function fetchWebUpdateFolder<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IWebUpdateFolderOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TWebUpdateFolderResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createWebUpdateFolderModel(parameters),
    config,
  )) as FetchResponse<TWebUpdateFolderResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IFolderResponse2, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TWebUpdateFolderResponse>;
}
